import '@fontsource-variable/inter/index.css'

import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { Provider } from '@/components/ui'

import { initializeAWSAmplify } from './lib/aws-amplify'
import { initializeSentry } from './lib/sentry'
import { routeTree } from './routeTree.gen'

// Set up a Router instance
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
})

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
  interface HistoryState {
    from: string
  }
}

initializeAWSAmplify()
initializeSentry({ router })

const rootElement = document.getElementById('app')!

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <Provider forcedTheme="light">
        <RouterProvider router={router} />
      </Provider>
    </StrictMode>,
  )
}
